export default __webpack_public_path__ + "static/media/master-builders-logo.0d4703f5.png";